import styled from "styled-components";
import { breakpoints } from "@tvg/design-system";

export const Container = styled.div`
  padding: ${({ theme }) => theme.space["space-4"]};

  @media screen and ${breakpoints.tablet.max.sm} {
    p[data-qa-label="change-jockey"] {
      display: flex;
    }

    p[data-qa-label="change-date"] {
      flex-shrink: 0;
    }
  }
`;

export const ChangeWrapper = styled.div`
  margin: 2px 0;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;
